/*global
*/

export default class Header {
    constructor() {
        this.init();
    }

    init () {

        const primaryNavLink = Array.from(document.querySelectorAll('nav.nav-primary a'));
        primaryNavLink.forEach(link => link.addEventListener('focusin', () => {
            const parentItem = link.closest('.navigation-menu_main') || link.closest('.secondary-menu_item');
            const menuItemHasChildren = link.closest('.menu-item-has-children');
            parentItem && parentItem.classList.add('sfhover');
            menuItemHasChildren && menuItemHasChildren.classList.add('sfhover');
            link.addEventListener('focusout', () => {
                parentItem && parentItem.classList.remove('sfhover');
                menuItemHasChildren && menuItemHasChildren.classList.remove('sfhover');
            }, { once: true })
        }));

    }
}



// WEBPACK FOOTER //
// ./scripts/components/header.js